<template>
  <ellipse cx="7.5" cy="7.99998" rx="7.5" ry="7.49998" fill="#06D6A0" />
  <path
    d="M4 8.77127L6.18036 10.6927L11 5.66016"
    stroke="white"
    stroke-width="1.48536"
    stroke-linecap="round"
  />
</template>
